import { createFileRoute, Outlet } from '@tanstack/react-router'

/** Layout for File View (`/knowledge-base` + `/knowledge-base/$kbId` history). */
export const Route = createFileRoute('/_app/knowledge-base')({
  component: KnowledgeBaseLayoutRoute,
})

function KnowledgeBaseLayoutRoute() {
  return <Outlet />
}
